export default __webpack_public_path__ + "static/media/vg.6d181c67.svg";